import { toChineseNumber } from "@/utils/str"

export enum DictEnum {
  SubjectClassify = 'subjectClassify',
}
export const Dict_SubjectClassify = 'subjectClassify'  // 科目属性归类
export const Dict_FieldClassifi = 'fieldClassify'  // 字段归类
export const Dict_EngFeature = 'ProjectCharacter'  // 工程特征
export const Dict_ProjectInfo = "projectinformation" // 项目信息
export const Dict_engineeringInfo = "gcxx" // 工程信息
export const Dict_SubjectAttributes = "subjectAttributes" // 科目属性
export const Dict_ProjectType = 'projectFieldType' // 项目类型，数字，文本等
export const Dict_FeatureType = 'feature_type' //   特征类型
export const Dict_Enum = 'enum' // 项目类型，数字，文本等
export const Dict_Caliber = 'caliber' // 计算口径
export const Dict_ProjectPhase = 'ProjectPhase' // 项目阶段
export const Dict_EngUnit = 'engUnit' //
export const Dict_EngUnit_Label = '工程单位' //
export const Dict_Enum_Label = '枚举' //
export const Dict_Required = "required" // 是否必填
export const Dict_EngineeringClassification = "EngineeringType" // 工程分类
export const Dict_EngineeringClassificationUnit = "projectCategoryUnit" //  
export const Dict_EngineeringSpecialty = "EngineeringSpecialty" // 工程专业
export const Dict_DatasourceType = 'datasourceType' // 数据源类型
export const Dict_DatasourceType_Dict = 'dict' // 数据源类型: 字典
export const Dict_ProjectFieldType = 'projectFieldType' // 字段类型
export const Dict_CostingPhase = 'CostingPhase' // 造价阶段
export const Dict_IndicatorStandard = 'IndicatorStandard' // 指标标准
export const Dict_Estimate = 'gsgc' // 估算工程
export const Dict_InvoiceType = 'Indicator.DocumentType'
export const Dict_IndicatorStandard_FieldClassify = 'FieldClassify' // 指标标准-字段分类
export type Dict_EngineeringClassification_Type = typeof Dict_EngineeringClassification;
export type Dict_EngineeringSpecialty_Type = typeof Dict_EngineeringSpecialty;
export type Dict_EngFeature_Type = typeof Dict_EngFeature;
export type Dict_EngineeringInfo_Type = typeof Dict_engineeringInfo;
export type Dict_ProjectInfo_Type = typeof Dict_ProjectInfo;
export type Dict_CostingPhase_Type = typeof Dict_CostingPhase;

// 项目信息-二级字典
export const Dict_FieldClassifi_BaseInfo = "baseInfo" // 字段归类，基本信息
export const Dict_FieldClassifi_ContractInfo = "contractInfo" // 字段归类，合同信息
export const Dict_FieldClassifi_Participatingunits = "participatingunits" // 字段归类，参与单位
export const Dict_FieldClassifi_CostInformation = "CostInformation" // 字段归类，造价信息

// 科目属性-二级字典
export const Dict_SubjectClassify_Economic = "economicSubject" // 科目属性归类，经济指标科目

// 项目信息
export const Dict_ProjectInfo_ProjectName = "projectname"  // 项目名称
export const Dict_ProjectInfo_Projectlocation = "Projectlocation"  // 项目地点
export const Dict_ProjectInfo_Engineering_Type = "Engineering_Type"  // 工程分类 项目字段
export const Dict_ProjectInfo_Businessformat = "Businessformat"  // 工程业态
export const Dict_ProjectInfo_Projectnumber = "Projectnumber" // 项目编号
export const Dict_ProjectInfo_ProjectPhase = "ProjectPhase1" // 项目阶段
export const Dict_ProjectInfo_Projectscale = "Projectscale" // 项目规模
// export const Dict_ProjectInfo_Projectscale_Unit = "Project_Scale_Unit" // 项目规模单位
export const Dict_ProjectInfo_Projectscale_Unit = "ProjectScaleUnit" // 项目规模单位
export const Dict_ProjectInfo_Projectnature = "projectnature" // 项目性质
export const Dict_ProjectInfo_CommencementDate = "CommencementDate" // 开工日期
export const Dict_ProjectInfo_CompletionDate = "CompletionDate" // 竣工日期
export const Dict_ProjectInfo_FileType = "filetype" // 文件类型
export const Dict_ProjectInfo_TotalInvestment = "totalInvestment" // 项目总投资(元)
// 基本类型
export const Dict_ProjectType_Number = "Number"
export const Dict_ProjectType_Text = "Text"
export const Dict_ProjectType_Date = "Datetime"
export const Dict_ProjectType_Select = "Select"
export const Dict_ProjectType_MultiSelect = "Select_Multi"
export const Dict_ProjectType_Location = "location1"
// 补充
export const Dict_ProjectType_Tree = "Tree"
export const Dict_ProjectType_MultiTree = "Tree_Multi"
export const Dict_ProjectType_InputNumberSelect = "InputNumberSelect" // 数字+下拉框组合

// 工程信息
export const Dict_EngineeringInfo_EngName = "costName" // 工程名称
export const Dict_EngineeringInfo_EngCode = "costCode" // 工程编码
export const Dict_EngineeringInfo_CollectTemplate = "collTmpl" // 指标模板
export const Dict_EngineeringInfo_ProjectPhase = "projectPhase" // 造价阶段
export type Dict_EngineeringInfo_ProjectPhase_type = typeof Dict_EngineeringInfo_ProjectPhase   // 造价阶段
export const Dict_EngineeringInfo_Pricingtype = "Pricingtype" // 计价类型
export const Dict_EngineeringInfo_Listspecification = "Listspecification" // 清单标准
export const Dict_EngineeringInfo_Quotaspecification = "Quotaspecification" // 计价依据
export const Dict_EngineeringInfo_TaxMethod = "taxMethod" // 计税方式
export const Dict_EngineeringInfo_Dateofmaterialpricedetermination = "Dateofmaterialpricedetermination" // 材价取材日期

// 指标标准
export const Dict_INDICATOR_STANDARD_MC = "bi_mc" // 名称
export const Dict_INDICATOR_STANDARD_GCFL = "bi_gcfk" // 工程分类
export const Dict_INDICATOR_STANDARD_CJMB = "bi_cjmb" // 指标模板
export const Dict_INDICATOR_STANDARD_CKBZ = "bi_ckbz" // 参考标准
export const Dict_INDICATOR_STANDARD_YT = "s_yt" // 业态
export const Dict_INDICATOR_STANDARD_ZY = "s_zy" // 专业
export const Dict_INDICATOR_STANDARD_PHASE = "s_zjjd" // 造价阶段
export const Dict_INDICATOR_STANDARD_LOCATION = "s_dq"  // 地区
export const Dict_INDICATOR_STANDARD_CJQDRQ = "s_cjqdrq" // 材价取定日期

export const Dict_INDICATOR_STANDARD_FieldClassify_BaseInfo = "BaseInfo"
export const Dict_INDICATOR_STANDARD_FieldClassify_Scope = "Scope"

// 费率标准
// export const FeeRateStandard_GCFL = 'frs_gcfl'  // 工程分类
// export const FeeRateStandard_ZY = 'frs_zy'      // 专业
// export const FeeRateStandard_ZJJD = 'frs_zjjd'  // 造价阶段
// export const FeeRateStandard_SYDQ = 'frs_sydq'  // 适用地区
export const FeeRateStandard_GCFL = 'bi_gcfk'  // 工程分类
export const FeeRateStandard_ZY = 's_zy'      // 专业
export const FeeRateStandard_ZJJD = 's_zjjd'  // 造价阶段
export const FeeRateStandard_SYDQ = 's_dq'  // 适用地区

// 估算工程
// Dict_Estimate
export const Dict_Estimate_GCMC = 'gcmc'  // 工程名称
export const Dict_Estimate_GSBB = 'gsbb'  // 估算版本
// export const Dict_Estimate_GCFL = 'gcfl'  // 工程分类
export const Dict_Estimate_CJQDRQ = 'cjqdrq'  // 材价取定日期
export const Dict_Estimate_ZBMB = 'zbmb'  // 指标模板



// 计算口径 (工程特征）
// 建筑面积 1-0011
export const Dict_EngFeature_BuildingArea = "1-0011"
// 地上建筑面积 1-002
export const Dict_EngFeature_BuildingArea_Ground = "1-002"
// 地下建筑面积 1-003
export const Dict_EngFeature_BuildingArea_Underground = "1-003"
// 非人防车库面积 1-004
export const Dict_EngFeature_BuildingArea_NonPreventive = "1-004"
// 人防车库面积 1-005
export const Dict_EngFeature_BuildingArea_Preventive = "1-005"
// 景观面积 1-108
export const Dict_EngFeature_LandArea = "1-108"

// 10 ：含量-分子（工程量）， 11 ：含量-分子（工程造价）， 12 ：含量-分子（计算口径），
// 20 ：含量-分母（工程量）， 21 ：含量-分母（工程造价）， 22 ：含量-分母（计算口径）
export const fenziTypeArr = [10, 11, 12]
export const fenmuTypeArr = [20, 21, 22]
export const gclArr = [10, 20]
export const gczjArr = [11, 21]
export const jskjArr = [12, 22]

export const OTHER_FEE = "OTHER_FEE" // 其他费用
export const STAT_FEE = "STAT_FEE" // 规费
export const TAX_FEE = "TAX_FEE" // 税金

// 'slickgrid-edit-disabled'
export const SlickgridEditDisabledClassName = "slickgrid-edit-disabled"
export const dxColorClassName = 'dx_bg_color'
export const dwColorClassName = 'dw_bg_color'
export const fbfxColorClassName = 'fbfx_bg_color'
export const qdColorClassName = 'qd_bg_color'
export const deColorClassName = 'de_bg_color'
export const prjColorClassName = 'prj_bg_color'
export const prjDxColorClassName = 'prj_dx_bg_color'
export const prjDwColorClassName = 'prj_dw_bg_color'
export const SlickgridEditedMarkClassName = 'custom-edited-mark'



export const LEVEL_LABEL = Object.fromEntries(
  Array.from({ length: 10 }, (_, i) => [i + 1, `展开${toChineseNumber(i + 1)}级`])
);

export const LOCATION_OPTIONS = ['上海', '浙江', '江苏', '四川']

// 科目code
export const KM_CODE = {
  NOT_MATCH: 'NOT_MATCH',
}
// 特殊code，一般不重要，不显示，或者放在最后面
export const SPECIAL_KM_CODES = ['NOT_MATCH', 'ZJCS_FEE', 'OTHER_FEE', 'STAT_FEE', 'TAX_FEE']

export const ZBKM_HIDDEN_CODE_OPTIONS = ['NOT_MATCH', 'ZJCS_FEE', 'OTHER_FEE', 'STAT_FEE', 'TAX_FEE']
export const ZBKM_CODE_SYSTEM_OPTIONS = ['ROOT', 'NOT_MATCH', 'OTHER_FEE', 'STAT_FEE', 'TAX_FEE']
export const RN_CODE = 'ROOT'


// 默认企业epid
export const DEFAULT_EPID = '2285'

// 重复码
export const COST_REDO_CODE = 82011
export const PROJECT_REDO_CODES = [82010, 82012]

// 是否是快速上传标记
export const Uploaded = 'uploaded'

export const COST_HEIGHT = {
  header: 53,
  footer: 40
}

// 指标工程列表tab枚举
export enum EngListTabEnum {
  all = '-1',
  new = '0',
  collect = '1',
  audit = '2',
  storage = '3',
}
export const EngListTabs = [
  { label: '全部', key: EngListTabEnum.all },
  { label: '待上传', key: EngListTabEnum.new },
  { label: '采集中', key: EngListTabEnum.collect },
  { label: '审核中', key: EngListTabEnum.audit },
  { label: '已入库', key: EngListTabEnum.storage },
]
// 模块类型，0：工程分类，1：业态，2：专业，3：工程标签，4：计算口径
export enum CostComposeEnum {
  GCFL = 0,
  YT = 1,
  ZY = 2,
  GCBQ = 3,
  JSKJ = 4,
}

// 字典版本KEY枚举
export enum DefaultDictVersionEnum {
  published = 'published', // 已发布（系统，企业）
  unpublished = 'unpublished', // 未发布（系统，企业）
  system = 'system', // 系统字典
}

// 未处理费用项
export const UNPROCESSED_EXPENSE_ITEMS = "未处理费用项";


// 锁相关配置
export const LockConfig = {
  // 编辑页面锁时间。锁时间（单位：秒）	
  editLockTime: 70,
  // 编辑页面轮询锁时间（单位：秒），需要小于编辑页面锁时间
  editLockPollingTime: 60,
}

// 锁类型枚举
export enum LockCodeEnum {
  PROJECT = 'PROJECT',     // 项目锁
  DOCUMENT = 'DOCUMENT',   // 文档锁
}

// 校验设置
// 设置key
export const VerifySettingRange = 'range'
export const VerifySettingCalc = 'calc'
export const VerifySettingStandard = 'standard'
// 设置项
export const VerifySettingOptions = [
  {
    key: VerifySettingRange,
    label: '范围设置'
  }, {
    key: VerifySettingCalc,
    label: '计算设置'
  }, {
    key: VerifySettingStandard,
    label: '校验标准'
  },
]

// 码
export const VerifyCode = 'IND_CHECK_RULE'

export const rightSvg = title => `<svg title="${title}"   id="gridExpandIcon" class="gridExpandIcon" viewBox="0 0 24 24" style="height: 18px; width: 18px;"><path id="gridExpandIconPath" fill="currentColor" d="M12.08,4.08L20,12L12.08,19.92L10.67,18.5L16.17,13H2V11H16.17L10.67,5.5L12.08,4.08M20,12V22H22V2H20V12Z"></path></svg>`
export const leftSvg = title => `<svg title="${title}"  id="gridExpandIcon"  class="gridExpandIcon" viewBox="0 0 24 24" style="height: 18px; width: 18px;">
    <path id="gridExpandIconPath" fill="currentColor" d="M11.92,19.92L4,12L11.92,4.08L13.33,5.5L7.83,11H22V13H7.83L13.34,18.5L11.92,19.92M4,12V2H2V22H4V12Z" />
  </svg>`


export const upSvg = title => `<svg title="${title}"  id="gridExpandIcon"  viewBox="0 0 1024 1024" focusable ="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true" ><path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path></svg >`
export const downSvg = title => `<svg title="${title}"  id="gridExpandIcon"  viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path></svg>`

export const titleSortRender = (name: any, sortField: string | null, currentField: string, sortDirection: 'asc' | 'desc' | null) => {
  const isSorted = sortField === currentField;

  const colorAsc = isSorted && sortDirection === 'asc' ? '#1677ff' : '#0000004A';
  const colorDesc = isSorted && sortDirection === 'desc' ? '#1677ff' : '#0000004A';

  const titleHtml = `
    <div style="display: flex; align-items: center; justify-content: space-between; height: 100%;">
      <span style="flex: 1;">${name}</span>
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-left: 8px; margin-right: 8px;margin-bottom:5px">
        <span
          title="升序"
          style="color: ${colorAsc}; display: inline-block; width: 9px; height: 9px;"
        >
          ${upSvg('升序')}
        </span>
        <span
          title="降序"
          style="color: ${colorDesc}; display: inline-block; width: 9px; height: 9px;"
        >
          ${downSvg('降序')}
        </span>
      </div>
    </div>
  `;
  return titleHtml;
};
